import { Dimensions, Platform, View } from 'react-native'

import { styled } from '~/core/styled'

export const ScrimContainer = styled(View, theme => ({
  base: {
    display: 'flex',
    flex: 1,
    height: Platform.OS === 'web' ? Dimensions.get('window').height : '100%',
    width: Platform.OS === 'web' ? Dimensions.get('window').width : '100%',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 999,
  },
}))

export const ScrimBackground = styled(View, theme => ({
  base: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    top: 0,
    backgroundColor: theme.colorLabelingFillPrincipalDefault,
    height: Platform.OS === 'web' ? Dimensions.get('window').height : '100%',
    width: Platform.OS === 'web' ? Dimensions.get('window').width : '100%',
    opacity: theme.opacityLow / 100,
    borderRadius: theme.borderRadiusNone,
  },
}))
